// 注册、激活、登录、忘记密码、登出相关接口
import { connector } from 'services/base';

// 登录
export async function postLogin(props: { username: string; password: string }) {
  return connector.post<string>(`/api/pti/user/login`, props);
}

// 用户-用户登录相关：用户登出(退出)
export async function postUserLogout() {
  return connector.post<string>(`/api/pti/user/logout`);
}
